type AddButtonProps = {
  selected?: boolean;
  onClick: () => void;
  title: string;
};

export const AddButton = (props: AddButtonProps) => {
  const { selected, onClick, title } = props;
  return (
    <div
      className={`add-btn ${selected ? "selected" : ""}`}
      onClick={onClick}
      style={{ margin: "1em" }}
    >
      ➕ {title}
    </div>
  );
};
